export default "__VITE_PUBLIC_ASSET__484b93aa__"